import React from "react";
import { Select, makeStyles, useTheme } from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  menu: { height: 380 },
  select: {
    padding: "10px 14px",
    width: 140,
    borderRadius: 5,
    background: theme.palette.background.dark,
  },
}));

export const VehicleDataRowSelect = (props) => {
  const theme = useTheme();
  const classes = useStyles(theme);

  return (
    <Select
      className={classes.select}
      MenuProps={{
        className: classes.menu,
      }}
      {...props}
    />
  );
};

export default VehicleDataRowSelect;
